export default {
  timelineFlights: '{{count}} flights',
  timelineNet: 'Net {{value}}',
  timelineNoSpend: 'no media spend',
  timelineLineItems: '{{count}} line items',
  timelineQuarter: 'Quarter',
  timelineAllQuarters: 'All quarters',
  timelineZoom: 'Axis',
  timelineZoomQuarter: 'Quarter',
  timelineZoomMonth: 'Month',
  timelineZoomWeek: 'Week',
  timelineStatus: 'Status',
  timelineStatusAll: 'All',
  timelineStatusLive: 'Live',
  timelineStatusUpcoming: 'Upcoming',
  timelineStatusEnded: 'Ended',
  timelineSort: 'Sort by',
  timelineSortStart: 'Start date',
  timelineSortNet: 'Net (highest)',
  timelineSortDuration: 'Duration (longest)',
  timelineSortCampaign: 'Campaign name',
  timelineToday: 'Today',
  timelineDays: '{{count}} days',
  timelineShowingOf: 'Showing {{shown}} of {{total}}',
  timelineShowMore: 'Show {{count}} more',
  timelineNoneInRange: 'No flights in this quarter. Try another quarter or clear the filters.',
  timelineStatFlights: 'Flights',
  timelineStatNet: 'Net in view',
  timelineStatAverage: 'avg. flight',
  timelineCharts: 'Charts',
  timelineTipDates: 'Dates',
  timelineTipDuration: 'Duration',
  timelineTipMedia: 'Media',
  timelineTipLineItems: 'Line items',
  timelineChartVolumeTitle: 'Flights in market',
  timelineChartVolumeMonth: 'Campaigns live in each month of the range',
  timelineChartVolumeWeek: 'Campaigns live in each week of the range',
  timelineChartInMarket: 'In market',
  timelineChartNetInPeriod: 'Net in period',
  timelineChartNetTitle: 'Net over time',
  timelineChartNetHint: 'Spend apportioned across each flight’s days in market',
  timelineChartPeak: 'Peak',
  timelineChartAverage: 'Average',
  timelineChartTotal: 'Total',
  timelineChartMixTitle: 'Net by channel',
  timelineChartMixHint: 'Select a bar to filter the timeline',
  timelineChartFlights: 'Flights',
  totalCampaigns: '{{total}} campaigns',
  mixedValue: 'Mixed',
  lineItemsLoadFailed: 'Could not load this campaign’s line items.',
  tabBookings: 'Line Items',
  tabTimeline: 'Campaign Launch Timeline',
  timelineCampaign: 'Campaign',
  timelineEmpty: 'No campaign flights to show for these filters.',
  timelineLoadFailed: 'Could not load the campaign timeline.',
  title: 'Booking Database',
  searchPlaceholder: 'Search by advertiser, campaign, deal ID, channel, platform, country, PO…',
  searchLabel: 'Search line items',
  searchFieldLabel: 'Search',
  resetFilters: 'Reset filters',
  channelFilterLabel: 'Channel',
  platformFilterLabel: 'Platform',
  countryFilterLabel: 'Country',
  buyModelFilterLabel: 'Buy model',
  anyOption: 'Any',
  columnsToggle: 'Columns',
  columnsToggleLabel: 'Choose visible columns',
  summaryBookings: 'Line Items',
  summaryDeals: 'Campaigns',
  awaitingClientOrderNote:
    '{{lineItems}} line items across {{campaigns}} campaigns awaiting a client order · {{gross}}',
  awaitingClientOrderHint:
    'These campaigns are confirmed by us signing the client’s own order (Prisma or DocuSign) rather than the client signing our IO. They book once that signed order is attached to the media plan.',
  editTitle: 'Amend booking',
  editHint:
    'Amends are recorded against you with the reason given, and the previous values stay in the history. Figures are not recalculated from each other — if you change gross or discount, update net to match.',
  editSectionOperational: 'Operational',
  editSectionFlight: 'Flight and product',
  editSectionCommercial: 'Commercial',
  editHistoryTitle: 'Amend history',
  editHistoryLoading: 'Loading…',
  editHistorySystem: 'Booked automatically',
  editHistoryOriginal: 'Original booking, written when the IO was confirmed',
  editHistoryResigned: 'Rewritten when a revised IO was confirmed',
  editReason: 'Reason for the amend',
  editReasonRequired: 'Say why this is being amended.',
  editSave: 'Save amend',
  editSaved: 'Amend saved ({{count}} field changed).',
  editSaved_plural: 'Amend saved ({{count}} fields changed).',
  editNoChanges: 'Nothing has been changed.',
  editFailed: 'Could not save the amend. Try again.',
  summaryGross: 'Gross',
  summaryNet: 'Net',
  wonDate: 'Won date',
  dealId: 'Campaign ID',
  lineItemId: 'Line item',
  advertiser: 'Advertiser',
  campaign: 'Campaign',
  channel: 'Channel',
  platform: 'Platform',
  product: 'Product',
  format: 'Format',
  buyModel: 'Buy model',
  quantity: 'Quantity',
  currency: 'Currency',
  rate: 'Rate',
  gross: 'Gross',
  mediaSpend: 'Media spend',
  fee: 'Fee',
  discount: 'Discount',
  net: 'Net',
  po: 'PO',
  am: 'AM',
  trader: 'Trader',
  startDate: 'Start date',
  endDate: 'End date',
  buyingPoint: 'Buying point',
  targetingKpi: 'Targeting KPI',
  targetingDetails: 'Targeting details',
  country: 'Country',
  dataProvider: 'Data provider',
  audienceId: 'Audience ID',
  audienceStrategyId: 'Audience strategy ID',
  ioDocumentId: 'IO document',
  mediaPlanId: 'Media plan',
  totalItems: '{{total}} line items',
  noBookingsTitle: 'No line items yet',
  noBookingsSubtitle: 'Line items from signed IOs will appear here once they are booked.',
  noResultsTitle: 'No line items match your filters',
  noResultsSubtitle: 'Try adjusting or resetting your search and filters.',
  loadFailed: 'Failed to load line items.',
  summaryLoadFailed: 'Failed to load the summary.'
} as Record<string, string>;
